var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.667 28.8c7.069 0 12.8-5.73 12.8-12.8s-5.731-12.8-12.8-12.8c-7.07 0-12.8 5.73-12.8 12.8s5.73 12.8 12.8 12.8Zm5.931-14.868a1.6 1.6 0 0 0-2.263-2.263l-5.268 5.268-2.069-2.068a1.6 1.6 0 0 0-2.263 2.263l3.2 3.2a1.6 1.6 0 0 0 2.263 0l6.4-6.4Z",
    fill: "#00B574"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.6f989b3c3567b0d6484e58a18612f74b.svg";
export { ForwardRef as ReactComponent };